<template>
  <ApolloQuery
    :query="require('../graphql/GetInsightById.gql')"
    :variables="{ id: parseInt(this.$route.params.id) }"
  >
    <template slot-scope="{ result: { data }, isLoading }">
      <div v-if="isLoading" class="not-found">
        <div class="flex-container center">
          <v-progress-circular color="#1c1c1c" indeterminate />
        </div>
      </div>
      <div v-else-if="!data.GetInsightById.ok" class="not-found">
        Eror 404 : Not Found
      </div>
      <div v-else class="flex-container d-flex flex-column">
        <div class="relative flex-container d-flex flex-column ai-center">
          <div v-if="!isMobile" class="mg-150" />
          <div
            class="section-wrapper article d-flex flex-column"
            v-bind:class="{ 'mg-150': !isMobile, ' mg-50': isMobile }"
          >
            <div class="text-1 color-grey thin">
              {{
                `${data.GetInsightById.insight.category.name} > ${data.GetInsightById.insight.division.name}`
              }}
            </div>
            <div class="text-1 bold insight-title">
              {{ data.GetInsightById.insight.title }}
            </div>
            <div class="space-15" />
            <ul class="text-1 color-grey">
              <li>{{ data.GetInsightById.insight.timestamp }}</li>
              <li>{{ data.GetInsightById.insight.author }}</li>
            </ul>
            <div class="mg-50" />
          </div>
        </div>
        <div class="relative flex-container d-flex flex-column ai-center">
          <div
            class="section-wrapper article d-flex flex-column"
            v-html="data.GetInsightById.insight.body"
          />
          <div class="mg-50" />
        </div>
      </div>
      <div class="flex-container center">
        <div class="section-wrapper article d-flex flex-column">
          <v-btn text color="#131313" width="100px" @click="goBack">
            <v-icon>mdi-chevron-left</v-icon>돌아가기
          </v-btn>
        </div>
      </div>
      <div class="mg-50" />
    </template>
  </ApolloQuery>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  methods: {
    goBack() {
      this.$router.push("/insights");
    },
  },
};
</script>

<style scoped>
.insight-title {
  font-size: 28px;
}
</style>
